import { render } from "./PageB2SStocksAtxStrategy.vue?vue&type=template&id=70201936"
import script from "./PageB2SStocksAtxStrategy.vue?vue&type=script&lang=js"
export * from "./PageB2SStocksAtxStrategy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__